import styled, { css } from 'styled-components'

import { Option } from 'components/Option'

import { Color } from 'root-constants'

export const StyledSelectFocusArea = {
  Container: styled.div`
    max-width: 375px;
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 16px 24px 0;
    margin: 0 auto;
  `,
  Hero: styled.div`
    position: relative;

    width: 100%;
    aspect-ratio: 327 / 232;
    overflow: hidden;

    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 24px;

    margin-bottom: 24px;
  `,
  HeroImage: styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
  `,
  Badge: styled.p`
    position: absolute;
    top: 11px;
    left: 11px;

    display: flex;
    align-items: center;
    gap: 4px;

    font-size: 10px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0.85px;
    text-transform: uppercase;
    color: ${Color.GOLD_LIGHTER};

    background-color: ${Color.INK_DARKEST};
    border-radius: 12px;

    padding: 4px 8px;

    &::before {
      content: '';
      width: 3px;
      height: 3px;

      background-color: ${Color.GOLD_LIGHTER};
      border-radius: 50%;
    }
  `,
  Title: styled.p`
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    text-align: center;
    color: ${Color.INK_DARKEST};

    margin-bottom: 12px;
  `,
  Question: styled.p`
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: ${Color.INK_BASE};

    margin-bottom: 24px;
  `,
  Options: styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px 9px;
  `,
  Option: styled(Option)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;

    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    color: ${Color.INK_DARKER};

    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 48px;
    transition:
      background-color 200ms ease-out,
      box-shadow 200ms ease-out;

    padding: 12px;

    ${({ checked }) =>
      checked &&
      css`
        background-color: ${Color.GOLD_LIGHTEST};
        box-shadow: 0 0 0 1.5px ${Color.GOLD_LIGHT};
      `}

    & svg {
      flex-shrink: 0;
    }
  `,
  Terms: styled.div`
    width: 100%;

    padding-top: 32px;
    margin-top: auto;
  `,
  TermsNote: styled.p`
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    text-align: center;
    color: ${Color.INK_LIGHT};

    padding: 24px 0;
  `,
}
